/*
 * File: UI.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Observable store to set values for the Orders UI to observe
 */
import { getEnv, types } from "mobx-state-tree";
import Preferences from "services/preferences/Store";

const Store = types
  .model("OrdersUIStore", {
    filterTabValue: "mine",
    keyword: "",
    showFiltersDialog: false,
    defaultTabLoaded: false,
    showPatientSelection: false
  })
  .actions(self => ({
    afterCreate: () => {
      const value = getEnv(self).storeManager.getPreference(
        "defaultOrdersView"
      );
      if (value) self.filterTabValue = value;
      self.defaultTabLoaded = true;
    },

    updateFilterTabValue: value => {
      self.filterTabValue = value;
      getEnv(self)
        .storeManager.getStore(Preferences)
        .apply("defaultOrdersView", value);
    },

    toggleFiltersDialog: () => {
      self.showFiltersDialog = !self.showFiltersDialog;
    },

    //Used for the patient search for a new order via orders tab
    togglePatientSelection: () => {
      self.showPatientSelection = !self.showPatientSelection;
    }
  }));

export default Store;
